(function () {
    "use strict";
    var translateModule = angular.module("common.translate", ["ngCookies", "pascalprecht.translate"]);
    translateModule.config(["$translateProvider", function ($translateProvider) {
            $translateProvider.useStaticFilesLoader({
                files: [
                    { prefix: "/app/i18n/", suffix: "/dist/combined.json" }
                ]
            });
            $translateProvider.useCookieStorage();
            //$translateProvider.determinePreferredLanguage(); //TODO - PBI - Test how well this works https://angular-translate.github.io/docs/#/guide/07_multi-language
            $translateProvider.preferredLanguage("en-CA");
            $translateProvider.useSanitizeValueStrategy("escaped");
        }]);
}());
